export default __webpack_public_path__ + "static/media/diamond-cut-1@3x.627c46a5.png";